export class LogisticResponse {

    trackingNumber?: string;

    bonTransportName?: string;

    bonTransportBase64?: string;

}
